module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_1.a4429289.png";